import { combineReducers } from 'redux';

import configReducer from 'src/redux/reducers/config';
import imagesReducer from 'src/redux/reducers/images';
import contextReducer from 'src/redux/reducers/context';
import counterReducer from 'src/redux/reducers/counter';
import credentialsReducer from 'src/redux/reducers/credentials';
import offersReducer from 'src/redux/reducers/offers';
import toastReducer from 'src/redux/reducers/toast';


export default combineReducers({
  configReducer,
  imagesReducer,
  contextReducer,
  counterReducer,
  credentialsReducer,
  offersReducer,
  toastReducer
});
